<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-alert
                    outlined
                    type="warning"
                    prominent
                    border="left"
                >
                    You are viewing the applicant view of the CUPE Application Portal. Please be aware that you will not be able to edit any information or details for this account. 
                </v-alert>
                <v-row height="100%">
                    <v-col md="2">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-h6">
                                    {{ person.firstname+" "+person.lastname }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                <br />
                                    <v-img src="../../../assets/background/Kings_international_3308.jpg" height="150px" contain></v-img>
                                <br />
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list dense>
                            <v-list-item-group v-model="navigation">
                                <v-list-item
                                    v-for="item in items"
                                    :key="item.title"
                                    :color="item.color"
                                    :value="item.title"
                                >
                                    <v-list-item-icon>
                                        <v-icon :color="item.color">{{ item.icon }}</v-icon>
                                    </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>
                                            {{ item.title }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-col>
                    <v-col md="10">
                        <Home v-if="navigation == 'Home'" />
                        <Profile v-if="navigation == 'Profile'" />
                        <MyApplications v-if="navigation == 'My Applications'" />
                        <BrowsePostings v-if="navigation == 'Browse Postings'" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>     
    </div>
</template>
<script>
import Home from "@/views/Applicants/Home/Home.vue"
import Profile from "@/views/Applicants/Items/Profile.vue"
import MyApplications from "@/views/Applicants/Items/MyApplications.vue"
import BrowsePostings from "@/views/Applicants/Items/BrowsePostings.vue"

export default {
    props: {
        person: {
            required: true
        }
    },
    components: {
        Home,
        Profile,
        MyApplications,
        BrowsePostings
    },
    data(){
        return {
            navigation: "Home",
            items: [
                { 
                    title: "Home", 
                    icon: "mdi-home-outline", 
                    color: "#2E7D32"
                },
                { 
                    title: "Profile", 
                    icon: "mdi-account-circle-outline", 
                    color: "#00ACC1"
                },
                { 
                    title: "My Applications", 
                    icon: "mdi-list-status", 
                    color: "#7CB342"
                },
                { 
                    title: "Browse Postings", 
                    icon: "mdi-view-grid-plus-outline", 
                    color: "#33675E"
                }
            ]
        }
    }
}
</script>
<style scoped>
tr {
    height: 25px;
}
</style>